import { render, staticRenderFns } from "./split-payment-configuration.vue?vue&type=template&id=d4b2d338&scoped=true"
import script from "./split-payment-configuration.vue?vue&type=script&lang=js"
export * from "./split-payment-configuration.vue?vue&type=script&lang=js"
import style0 from "./split-payment-configuration.vue?vue&type=style&index=0&id=d4b2d338&prod&scoped=true&lang=css"
import style1 from "./split-payment-configuration.vue?vue&type=style&index=1&id=d4b2d338&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b2d338",
  null
  
)

export default component.exports